module.exports = __webpack_public_path__ + "static/img/eicad_img@2x.b1f0accb.png";